module.exports = __webpack_public_path__ + "img/Weapon_149.7505ce91.png";